import request from '@/utils/request'

export function articleList(params) {
  return request({
    url:'/website/websiteArticle/open/list',
    method:'get',
    params:params
  })
}

export function articleDetail(params) {
  return request({
    url:'/website/websiteArticle/open/'+params.id,
    method:'get'
  })
}


export function registerMember(data) {
  return request({
    url:'/user/survey/create',
    method:'post',
    data
  })
}

export function getAdvertise(params) {
  return request({
    url:'/sms/smsHomeAdvertise/list',
    method:'get',
    params:params,
  })
}

